import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextInput } from "../FormInputs/TextInput";
import { Submit } from "../FormInputs/Submit";
import {
	LoginWrapper,
	LeftSection,
	RightSection,
	LoginSection,
} from "./styled";
import { Heading } from "../Heading";
import { LogoWrapper } from "../LogoWrapper/LogoWrapper";
import rightImg from "./../../icons/login-right-img.jpg";
import { navigate } from "@reach/router";
import { useMutation } from "@tanstack/react-query";
import { identifyUser } from "../../actions/authActions";
import { showToast } from "../../utils/helpers";
import { FlashError } from "components/FormInputs/FlashError";
import { useEffect } from "react";

export const LoginEmailOnly = () => {
	const isSessionTimeout = localStorage.getItem("session_timeout");

	const mutation = useMutation({
		mutationKey: ["identifyUser"],
		mutationFn: identifyUser,
		onSuccess: (result, variables) => {
			if (result && result.type) {
				let redirectPath = "";

				switch (result.type) {
					case "member":
						redirectPath = `/member/login`;
						break;
					case "existing_guest":
						redirectPath = `/guest/login`;

						break;
					case "new_guest":
						redirectPath = `/guest/signup`;
						break;
					default:
						showToast("Unknown user type received.", "Error");
						return;
				}
				localStorage.setItem("user_identified_type", result.type);
				localStorage.removeItem("session_timeout");
				// Pass email via state during navigation
				navigate(redirectPath, { state: { email: variables } });
			} else {
				showToast("Could not determine user type.", "Error");
			}
		},
		onError: (error) => {
			console.error("Mutation failed in onError:", error);
		},
	});

	const handleLoginSubmit = (values, { setSubmitting }) => {
		mutation.mutate(values.email);
	};

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const rit = params.get("rit");
		if (rit) {
			localStorage.setItem("RIT", rit);
		}
	}, []);

	return (
		<LoginWrapper>
			<LeftSection>
				<LogoWrapper />
				<LoginSection>
					<Heading marginBottom="40px">
						<span className="welcome">Welcome.</span>
					</Heading>
					<p className="mb-10 max-w-[400px] text-xl text-primary-900">
						We’ll check if you have an account, and help create one if you
						don't.
					</p>
					{isSessionTimeout ? (
						<FlashError
							heading="Session timeout"
							text="You have been logged out due to inactivity you will need to login again"
						/>
					) : (
						<></>
					)}
					<Formik
						initialValues={{ email: "" }}
						validationSchema={Yup.object({
							email: Yup.string().email().required("Email is required"),
						})}
						onSubmit={handleLoginSubmit}
					>
						{({ isSubmitting }) => (
							<Form>
								<div className="row">
									<TextInput
										label="Enter your email"
										placeholder="Email"
										name="email"
										type="email"
										className="col xl-12"
										testId="login-email"
									/>
									<div className="col xl-12">
										<Submit
											type="submit"
											widthExpand
											marginTop="24px"
											isSubmitting={mutation.isLoading}
											text="Continue"
											submittingText="Checking..."
											style={{ textTransform: "uppercase", textLine: "1.25" }}
											testId="login-button"
										/>
									</div>
								</div>
							</Form>
						)}
					</Formik>
				</LoginSection>
			</LeftSection>
			<RightSection style={{ backgroundImage: `url(${rightImg})` }} />
		</LoginWrapper>
	);
};
